export default {
	state: {
		layout: sessionStorage.getItem('role') || localStorage.getItem('layout') || 'client',
	},
	mutations: {
		setLayout(state, layout) {
			console.log(layout);
			state.layout = layout;
			localStorage.setItem('layout',layout)
		},
		setLocalLayout(state, layout) {
			console.log(layout)
			state.layout = layout;
		},
	},
	actions: {
		changeLayout({commit}, layout) {
			commit('setLayout', layout)
		}
	},
	getters: {
		getLayout: state => state.layout.toLowerCase(),
	}
}
